// extracted by mini-css-extract-plugin
export default {"user_right":"UserRight_user_right__ttxF6"};